import { _ } from '@ngx-translate/core';

export const MEMBERSHIP_STATUS = {
  paid: '',
  expireInTwoWeeks: _('components.navigationMessage.constants.membershipStatus.expireInTwoWeeks'),
  expireInMonth: _('components.navigationMessage.constants.membershipStatus.expireInMonth'),
  expired: _('components.navigationMessage.constants.membershipStatus.expired'),
};
